/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { Widget } from 'features/types'

import PlaceHolder from '../../../share/PlaceHolder'
import { TopicNotSelectedGuard, WidgetLoadingGuard } from '../../share/guards'
import SourceDonutWidgetDataGuard from './guards/SourceDonutWidgetDataGuard'
import RunSearchEffect from './RunSearchEffect'
import Donut from './Donut'

const SourceDonut: Widget = ({ widgetId }) => (
  // TODO: Log each go on widget (migration from V3)

  <ErrorBoundary FallbackComponent={({ error }) => <PlaceHolder>{error.message}</PlaceHolder>}>
    <TopicNotSelectedGuard widgetId={widgetId}>
      <RunSearchEffect widgetId={widgetId}>
        <WidgetLoadingGuard widgetId={widgetId}>
          <SourceDonutWidgetDataGuard widgetId={widgetId}>
            <Donut widgetId={widgetId} />
          </SourceDonutWidgetDataGuard>
        </WidgetLoadingGuard>
      </RunSearchEffect>
    </TopicNotSelectedGuard>
  </ErrorBoundary>
)

export default SourceDonut
